import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { githubProjects } from '../../mocks/projects';
import { events } from '../../mocks/events';
import { useState } from 'react';

const HomePage = () => {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  const fadeInUp = {
    initial: { opacity: 0, y: 60 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.6 }
  };

  const expertiseAreas = [
    {
      icon: 'https://public.readdy.ai/ai/img_res/389b0684ed3e9d2e0b1dc7070cec0cec.jpg',
      title: 'Microsoft Sentinel',
      description: 'Bulut tabanlı SIEM ve SOAR çözümü ile gelişmiş tehdit avı, güvenlik analizi ve olay müdahalei konularında uzmanlaşmış içerikler.',
      link: '/sentinel'
    },
    {
      icon: 'https://readdy.ai/api/search-image?query=Microsoft%20Intune%20endpoint%20management%20icon%20in%20modern%20minimalist%20style%20with%20orange%20and%20red%20gradient%20colors%20on%20clean%20white%20background%2C%20mobile%20device%20security%20symbol%20with%20high%20quality%20digital%20illustration&width=120&height=120&seq=intune-icon-003&orientation=squarish',
      title: 'Microsoft Intune',
      description: 'Modern cihaz yönetimi, endpoint güvenliği, uygulama koruma politikaları ve mobil cihaz yönetimi çözümleri.',
      link: '/intune'
    },
    {
      icon: 'https://readdy.ai/api/search-image?query=Microsoft%20Defender%20for%20Endpoint%20EDR%20cybersecurity%20icon%20in%20modern%20minimalist%20style%20with%20red%20and%20crimson%20gradient%20colors%20on%20clean%20white%20background%2C%20threat%20detection%20bug%20shield%20symbol%2C%20high%20quality%20digital%20illustration&width=120&height=120&seq=edr-icon-005&orientation=squarish',
      title: 'Microsoft EDR',
      description: 'Defender for Endpoint ile uç nokta tehdit algılama, otomatik soruşturma, saldırı yüzeyi azaltma ve güvenlik açığı yönetimi.',
      link: '/edr'
    },
    {
      icon: 'https://readdy.ai/api/search-image?query=GitHub%20open%20source%20code%20icon%20in%20modern%20minimalist%20style%20with%20dark%20gray%20and%20white%20colors%20on%20clean%20white%20background%2C%20collaboration%20coding%20symbol%20with%20brackets%2C%20high%20quality%20digital%20illustration&width=120&height=120&seq=github-icon-004&orientation=squarish',
      title: 'Açık Kaynak Projeler',
      description: 'GitHub üzerinde paylaştığım güvenlik araçları, otomasyon scriptleri ve topluluk odaklı güvenlik projeleri.',
      link: '/projects'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative min-h-[85vh] flex items-center overflow-hidden">
        <div
          className="absolute inset-0 bg-gradient-to-br from-[#0F1419] via-[#1A2332] to-[#0F1419]"
          style={{
            backgroundImage: `radial-gradient(circle at 20% 50%, rgba(0, 120, 212, 0.1) 0%, transparent 50%),
                             radial-gradient(circle at 80% 80%, rgba(0, 120, 212, 0.08) 0%, transparent 50%),
                             repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(255,255,255,0.03) 2px, rgba(255,255,255,0.03) 4px)`
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>

        <div className="relative max-w-7xl mx-auto px-8 w-full">
          <div className="grid grid-cols-2 gap-16 items-center">
            {/* Sol Taraf */}
            <motion.div {...fadeInUp} className="space-y-6">
              <div className="inline-block px-4 py-2 bg-white/10 backdrop-blur-sm border border-blue-500/30 rounded-lg">
                <span className="text-blue-400 text-sm font-medium">Microsoft Security Blog&nbsp;</span>
              </div>

              <h1 className="text-5xl font-bold text-white leading-tight">
                Microsoft Security &amp; Açık Kaynak Deneyimleri
              </h1>

              <p className="text-xl text-white/85 leading-relaxed">
                Sadece teorik değil, sahada çalışan çözümler. Sentinel, Intune ve EDR ekseninde güvenlik mimarileri, otomasyon araçları ve teknik rehberler.
              </p>

              <div className="flex items-center space-x-6 pt-4">
                <Link
                  to="/sentinel"
                  className="px-8 py-4 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-all cursor-pointer whitespace-nowrap shadow-lg shadow-blue-600/30"
                >
                  Keşfet
                </Link>
                <Link
                  to="/projects"
                  className="px-8 py-4 bg-transparent border-2 border-white hover:bg-white hover:text-gray-900 text-white font-medium rounded-lg transition-all cursor-pointer whitespace-nowrap"
                >
                  Projelerim
                </Link>
              </div>
            </motion.div>

            {/* Sağ Taraf - Kod Editör Mockup */}
            <motion.div
              initial={{ opacity: 0, x: 60 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="relative"
            >
              <div className="relative space-y-6">
                {/* Üst Pencere - KQL */}
                <div className="relative z-30 bg-[#1E1E1E] rounded-xl overflow-hidden shadow-2xl border border-blue-500/20">
                  <div className="flex items-center space-x-2 px-4 py-3 bg-[#2D2D30] border-b border-gray-700">
                    <div className="flex space-x-2">
                      <div className="w-3 h-3 rounded-full bg-red-500"></div>
                      <div className="w-3 h-3 rounded-full bg-yellow-500"></div>
                      <div className="w-3 h-3 rounded-full bg-green-500"></div>
                    </div>
                    <span className="text-xs text-gray-400 ml-4">sentinel-query.kql</span>
                  </div>
                  <div className="p-4 font-mono text-xs leading-relaxed">
                    <div className="text-purple-400">SecurityEvent</div>
                    <div className="text-gray-400">| <span className="text-blue-400">where</span> TimeGenerated &gt; <span className="text-orange-400">ago</span>(24h)</div>
                    <div className="text-gray-400">| <span className="text-blue-400">where</span> EventID <span className="text-purple-400">in</span> (4624, 4625)</div>
                    <div className="text-gray-400">| <span className="text-orange-400">summarize</span> Count = <span className="text-orange-400">count</span>()</div>
                    <div className="text-gray-400 ml-4"><span className="text-blue-400">by</span> Account, Computer</div>
                  </div>
                </div>

                {/* Orta Pencere - PowerShell */}
                <div className="relative z-20 bg-[#1E1E1E] rounded-xl overflow-hidden shadow-2xl border border-green-500/20 transform translate-x-8 -translate-y-4">
                  <div className="flex items-center space-x-2 px-4 py-3 bg-[#2D2D30] border-b border-gray-700">
                    <div className="flex space-x-2">
                      <div className="w-3 h-3 rounded-full bg-red-500"></div>
                      <div className="w-3 h-3 rounded-full bg-yellow-500"></div>
                      <div className="w-3 h-3 rounded-full bg-green-500"></div>
                    </div>
                    <span className="text-xs text-gray-400 ml-4">intune-compliance.ps1</span>
                  </div>
                  <div className="p-4 font-mono text-xs leading-relaxed">
                    <div className="text-green-400"># Connect to Microsoft Graph</div>
                    <div className="text-blue-400">Connect-MgGraph <span className="text-gray-400">-Scopes</span> <span className="text-orange-400">&quot;DeviceManagementConfiguration.Read.All&quot;</span></div>
                    <div className="text-blue-400 mt-2">Get-MgDeviceManagementDeviceCompliancePolicy</div>
                    <div className="text-gray-400">| <span className="text-blue-400">Export-Csv</span> <span className="text-orange-400">&quot;compliance.csv&quot;</span></div>
                  </div>
                </div>

                {/* Alt Pencere - JSON */}
                <div className="relative z-10 bg-[#1E1E1E] rounded-xl overflow-hidden shadow-2xl border border-orange-500/20 transform translate-x-16 -translate-y-8">
                  <div className="flex items-center space-x-2 px-4 py-3 bg-[#2D2D30] border-b border-gray-700">
                    <div className="flex space-x-2">
                      <div className="w-3 h-3 rounded-full bg-red-500"></div>
                      <div className="w-3 h-3 rounded-full bg-yellow-500"></div>
                      <div className="w-3 h-3 rounded-full bg-green-500"></div>
                    </div>
                    <span className="text-xs text-gray-400 ml-4">intune-config.json</span>
                  </div>
                  <div className="p-4 font-mono text-xs leading-relaxed">
                    <div className="text-gray-400">{'{'}</div>
                    <div className="text-gray-400 ml-4"><span className="text-blue-400">&quot;displayName&quot;</span>: <span className="text-orange-400">&quot;Compliance Policy&quot;</span>,</div>
                    <div className="text-gray-400 ml-4"><span className="text-blue-400">&quot;passwordRequired&quot;</span>: <span className="text-purple-400">true</span>,</div>
                    <div className="text-gray-400 ml-4"><span className="text-blue-400">&quot;minimumPasswordLength&quot;</span>: <span className="text-green-400">8</span></div>
                    <div className="text-gray-400">{'}'}</div>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Uzmanlık Alanları */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-8">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-4xl font-bold text-center text-gray-900 mb-16"
          >
            Uzmanlık Alanlarım
          </motion.h2>

          <div className="grid grid-cols-4 gap-6 max-w-5xl mx-auto">
            {expertiseAreas.map((area, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                whileHover={{ y: -8 }}
                className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-2xl hover:shadow-blue-600/10 transition-all border border-gray-100 cursor-pointer"
              >
                <div className="w-14 h-14 mb-5">
                  <img src={area.icon} alt={area.title} className="w-full h-full object-contain" />
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">{area.title}</h3>
                <p className="text-sm text-gray-600 leading-relaxed mb-4">{area.description}</p>
                <Link
                  to={area.link}
                  className="inline-flex items-center text-sm text-blue-600 hover:text-blue-700 font-medium cursor-pointer"
                >
                  Detaylı İncele <i className="ri-arrow-right-line ml-1"></i>
                </Link>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* GitHub Projeleri */}
      <section className="py-24 bg-gray-50">
        <div className="max-w-7xl mx-auto px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="mb-12"
          >
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Projelerim</h2>
            <p className="text-lg text-gray-600">Açık kaynaklı güvenlik araçları ve otomasyon scriptleri</p>
          </motion.div>

          {/* IntuneVault - Flagship Project */}
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="mb-16 relative"
          >
            <div className="bg-gradient-to-br from-emerald-50 via-white to-teal-50 rounded-2xl overflow-hidden shadow-2xl border-2 border-emerald-200">
              <div className="grid grid-cols-2 gap-0">
                {/* Sol Taraf - Görsel */}
                <div className="relative bg-gradient-to-br from-emerald-600 to-teal-700 p-12 flex items-center justify-center overflow-hidden">
                  <div className="absolute inset-0 opacity-10">
                    <div className="absolute inset-0" style={{
                      backgroundImage: 'repeating-linear-gradient(45deg, transparent, transparent 20px, rgba(255,255,255,0.1) 20px, rgba(255,255,255,0.1) 40px)'
                    }} />
                  </div>

                  <div className="relative z-10 text-center">
                    <div className="w-32 h-32 mx-auto mb-6 bg-white rounded-3xl shadow-2xl flex items-center justify-center">
                      <span className="text-6xl">🔐</span>
                    </div>
                    <h3 className="text-4xl font-bold text-white mb-3">IntuneVault</h3>
                    <div className="inline-block px-4 py-2 bg-white/20 backdrop-blur-sm rounded-lg mb-4">
                      <span className="text-white text-sm font-medium">&nbsp;Intune&nbsp;Policy Management &amp; Comparison Tool&nbsp;</span>
                    </div>

                    {/* v8.3 What's New */}
                    <div className="mt-6 space-y-3 text-left">
                      <div className="flex items-start space-x-3 bg-white/15 rounded-xl p-3">
                        <span className="text-lg shrink-0">🕵️</span>
                        <div>
                          <div className="text-white text-xs font-bold mb-0.5">Integrated Audit Logs</div>
                          <p className="text-white/75 text-[11px] leading-relaxed">Kim, neyi, ne zaman değiştirdi? Tek tık uzağınızda.</p>
                        </div>
                      </div>
                      <div className="flex items-start space-x-3 bg-white/15 rounded-xl p-3">
                        <span className="text-lg shrink-0">🕰️</span>
                        <div>
                          <div className="text-white text-xs font-bold mb-0.5">Legacy Support <span className="text-[10px] font-normal opacity-80">(v8.0 &amp; v8.1)</span></div>
                          <p className="text-white/75 text-[11px] leading-relaxed">Geçmiş verileriniz otomatik olarak yeni arayüze taşınıyor.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Sağ Taraf - İçerik */}
                <div className="p-12 flex flex-col justify-center">
                  <div className="flex items-center space-x-2 mb-4">
                    <div className="inline-block px-3 py-1 bg-emerald-100 text-emerald-700 text-xs font-bold rounded-full">
                      WEB APPLICATION
                    </div>
                    <div className="inline-block px-3 py-1 bg-amber-100 text-amber-700 text-xs font-bold rounded-full">
                      v8.3 YENİ
                    </div>
                  </div>

                  <h4 className="text-2xl font-bold text-gray-900 mb-4">
                    &nbsp;Intune Management Platform
                  </h4>

                  <p className="text-base text-gray-700 leading-relaxed mb-6">
                    Kapsamlı politika analitiği, gerçek zamanlı izleme ve gelişmiş güvenlik içgörüleri — hepsi tek bir güçlü dashboard&apos;da.
                    Microsoft kimlik doğrulaması ile anında erişim sağlayan profesyonel yönetim aracı.
                  </p>

                  {/* Özellikler */}
                  <div className="grid grid-cols-2 gap-3 mb-6">
                    <div className="flex items-start space-x-2">
                      <i className="ri-check-line text-emerald-600 text-lg mt-0.5"></i>
                      <span className="text-sm text-gray-700">6 İnteraktif Grafik</span>
                    </div>
                    <div className="flex items-start space-x-2">
                      <i className="ri-check-line text-emerald-600 text-lg mt-0.5"></i>
                      <span className="text-sm text-gray-700">Gerçek Zamanlı İzleme</span>
                    </div>
                    <div className="flex items-start space-x-2">
                      <i className="ri-check-line text-emerald-600 text-lg mt-0.5"></i>
                      <span className="text-sm text-gray-700">Güvenlik Politikası Analizi</span>
                    </div>
                    <div className="flex items-start space-x-2">
                      <i className="ri-check-line text-emerald-600 text-lg mt-0.5"></i>
                      <span className="text-sm text-gray-700">CSV Dışa Aktarma</span>
                    </div>
                    <div className="flex items-start space-x-2">
                      <i className="ri-file-search-line text-amber-500 text-lg mt-0.5"></i>
                      <span className="text-sm text-gray-700 font-medium">Audit Logs <span className="text-amber-600 text-xs font-bold">YENİ</span></span>
                    </div>
                    <div className="flex items-start space-x-2">
                      <i className="ri-history-line text-sky-500 text-lg mt-0.5"></i>
                      <span className="text-sm text-gray-700 font-medium">Legacy Support <span className="text-sky-600 text-xs font-bold">YENİ</span></span>
                    </div>
                  </div>

                  {/* Teknolojiler */}
                  <div className="flex flex-wrap gap-2 mb-6">
                    <span className="px-3 py-1 bg-blue-100 text-blue-700 text-xs font-medium rounded-full">React</span>
                    <span className="px-3 py-1 bg-purple-100 text-purple-700 text-xs font-medium rounded-full">TypeScript</span>
                    <span className="px-3 py-1 bg-cyan-100 text-cyan-700 text-xs font-medium rounded-full">Microsoft Graph API</span>
                    <span className="px-3 py-1 bg-orange-100 text-orange-700 text-xs font-medium rounded-full">Chart.js</span>
                  </div>

                  {/* Butonlar */}
                  <div className="flex items-center space-x-4">
                    <a
                      href="https://www.intune-vault.com/"
                      target="_blank"
                      rel="nofollow noopener noreferrer"
                      className="px-6 py-3 bg-emerald-600 hover:bg-emerald-700 text-white font-medium rounded-lg transition-colors cursor-pointer whitespace-nowrap shadow-lg shadow-emerald-600/30"
                    >
                      <i className="ri-external-link-line mr-2"></i>
                      Hemen Dene
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Diğer Projeler */}
          <div className="mb-6">
            <div className="flex items-center space-x-3">
              <div className="h-px flex-1 bg-gradient-to-r from-transparent to-gray-300"></div>
              <span className="px-4 py-1.5 bg-gray-100 text-gray-600 text-xs font-bold rounded-full tracking-wider">
                OTHER PROJECTS
              </span>
              <div className="h-px flex-1 bg-gradient-to-l from-transparent to-gray-300"></div>
            </div>
          </div>

          <div className="flex justify-center pb-6">
            {githubProjects.filter(p => p.name !== 'IntuneVault').map((project, index) => (
              <motion.div
                key={project.id}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="w-full max-w-2xl bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow cursor-pointer"
              >
                <div className="relative h-52 bg-[#1E1E1E] p-5 overflow-hidden">
                  <div className="absolute top-3 left-3 px-3 py-1.5 bg-blue-600 text-white text-xs font-semibold rounded-md">
                    {project.language}
                  </div>
                  <pre className="text-xs text-gray-300 font-mono leading-relaxed mt-10">
                    {project.codePreview.substring(0, 300)}...
                  </pre>
                </div>
                <div className="p-8">
                  <h3 className="text-xl font-bold text-gray-900 mb-3">{project.name}</h3>
                  <p className="text-sm text-gray-600 leading-relaxed mb-5">{project.description}</p>
                  <div className="flex items-center justify-between">
                    <div className="flex items-center space-x-5 text-sm text-gray-500">
                      <span className="flex items-center">
                        <i className="ri-star-fill text-yellow-500 mr-1"></i>
                        {project.stars}
                      </span>
                      <span className="flex items-center">
                        <i className="ri-git-branch-line mr-1"></i>
                        {project.forks}
                      </span>
                      {project.linkedin && project.linkedin.views > 0 && (
                        <span className="flex items-center">
                          <i className="ri-linkedin-fill text-blue-600 mr-1"></i>
                          {project.linkedin.views.toLocaleString()} views
                        </span>
                      )}
                    </div>
                    <a
                      href={project.url}
                      target="_blank"
                      rel="nofollow noopener noreferrer"
                      className="px-5 py-2.5 bg-gray-900 hover:bg-gray-800 text-white text-sm font-medium rounded-lg transition-colors cursor-pointer whitespace-nowrap"
                    >
                      <i className="ri-github-fill mr-2"></i>
                      GitHub
                    </a>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>

          <div className="text-center mt-8">
            <Link
              to="/projects"
              className="inline-block px-8 py-3 bg-gray-900 hover:bg-gray-800 text-white font-medium rounded-lg transition-colors cursor-pointer whitespace-nowrap"
            >
              Tüm Projeleri Görüntüle
            </Link>
          </div>
        </div>
      </section>

      {/* Etkinlik Sunumları */}
      <section className="py-24 bg-blue-50">
        <div className="max-w-7xl mx-auto px-8">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-4xl font-bold text-center text-gray-900 mb-16"
          >
            Etkinlikler
          </motion.h2>

          <div className="max-w-4xl mx-auto">
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="bg-white rounded-2xl p-12 shadow-xl relative"
            >
              <div className="mt-12 mb-8">
                <i className="ri-double-quotes-l text-5xl text-blue-600 opacity-20"></i>
                <p className="text-2xl text-gray-700 italic leading-relaxed mt-4">
                  &quot;{events[currentTestimonial].description}&quot;
                </p>
              </div>

              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-4">
                  <div className="w-14 h-14 bg-gradient-to-br from-blue-600 to-purple-600 rounded-full flex items-center justify-center text-white font-bold text-xl">
                    {events[currentTestimonial].name.charAt(0)}
                  </div>
                  <div>
                    <h4 className="text-lg font-bold text-gray-900">{events[currentTestimonial].title}</h4>
                    <p className="text-sm text-gray-600">{events[currentTestimonial].name}&nbsp;</p>
                  </div>
                </div>

                <div className="flex space-x-2">
                  <button
                    onClick={() => setCurrentTestimonial((prev) => (prev === 0 ? events.length - 1 : prev - 1))}
                    className="w-12 h-12 flex items-center justify-center border-2 border-gray-300 hover:border-gray-900 rounded-lg transition-colors cursor-pointer"
                  >
                    <i className="ri-arrow-left-line text-gray-700"></i>
                  </button>
                  <button
                    onClick={() => setCurrentTestimonial((prev) => (prev === events.length - 1 ? 0 : prev + 1))}
                    className="w-12 h-12 flex items-center justify-center bg-gray-900 hover:bg-gray-800 text-white rounded-lg transition-colors cursor-pointer"
                  >
                    <i className="ri-arrow-right-line"></i>
                  </button>
                </div>
              </div>
            </motion.div>
          </div>

          <div className="text-center mt-12">
            <Link
              to="/events"
              className="inline-block px-8 py-3 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-colors cursor-pointer whitespace-nowrap"
            >
              Tüm Etkinlikleri Görüntüle
            </Link>
          </div>
        </div>
      </section>

      {/* Uzmanlık Kartları */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-8">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-4xl font-bold text-center text-gray-900 mb-16"
          >
            Uzmanlık Konuları
          </motion.h2>

          <div className="grid grid-cols-3 gap-6">
            {/* Sentinel */}
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              whileHover={{ scale: 1.02 }}
              className="relative h-96 rounded-2xl overflow-hidden cursor-pointer group"
            >
              <div
                className="absolute inset-0"
                style={{
                  backgroundImage: 'linear-gradient(135deg, #0078D4 0%, #005A9E 100%)'
                }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-8">
                <h3 className="text-2xl font-bold text-white mb-2">Microsoft Sentinel</h3>
                <p className="text-lg text-white/90">SIEM &amp; SOAR</p>
                <Link
                  to="/sentinel"
                  className="inline-flex items-center mt-4 text-white font-medium opacity-0 group-hover:opacity-100 transition-opacity cursor-pointer"
                >
                  Keşfet <i className="ri-arrow-right-line ml-2"></i>
                </Link>
              </div>
            </motion.div>

            {/* Intune */}
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.1 }}
              whileHover={{ scale: 1.02 }}
              className="relative h-96 rounded-2xl overflow-hidden cursor-pointer group"
            >
              <div
                className="absolute inset-0"
                style={{
                  backgroundImage: 'linear-gradient(135deg, #F97316 0%, #DC2626 100%)'
                }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-8">
                <h3 className="text-2xl font-bold text-white mb-2">Microsoft Intune</h3>
                <p className="text-lg text-white/90">Endpoint Management</p>
                <Link
                  to="/intune"
                  className="inline-flex items-center mt-4 text-white font-medium opacity-0 group-hover:opacity-100 transition-opacity cursor-pointer"
                >
                  Keşfet <i className="ri-arrow-right-line ml-2"></i>
                </Link>
              </div>
            </motion.div>

            {/* EDR */}
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2 }}
              whileHover={{ scale: 1.02 }}
              className="relative h-96 rounded-2xl overflow-hidden cursor-pointer group"
            >
              <div
                className="absolute inset-0"
                style={{
                  backgroundImage: 'linear-gradient(135deg, #0078D4 0%, #005A9E 100%)'
                }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-8">
                <h3 className="text-2xl font-bold text-white mb-2">Microsoft EDR</h3>
                <p className="text-lg text-white/90">Endpoint Detection</p>
                <Link
                  to="/edr"
                  className="inline-flex items-center mt-4 text-white font-medium opacity-0 group-hover:opacity-100 transition-opacity cursor-pointer"
                >
                  Keşfet <i className="ri-arrow-right-line ml-2"></i>
                </Link>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Hakkımda */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-8">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center"
          >
            <div className="inline-block px-4 py-2 bg-gradient-to-r from-blue-100 to-indigo-100 rounded-lg mb-6">
              <span className="text-blue-700 text-sm font-semibold">HAKKIMDA</span>
            </div>
            <p className="text-lg text-gray-600 leading-relaxed" spellCheck="false">
              Microsoft Security ekosisteminde pratik çözümler üretmeye ve bu çözümleri açık kaynak projelerle topluluğa sunmaya odaklıyım. Sentinel&apos;den Intune&apos;a kadar geniş bir yelpazede, güvenliği bir zorunluluktan ziyade bir standart haline getirmek için çalışıyor, deneyimlerimi teknik içeriklerle meslektaşlarıma aktarmaktan keyif alıyorum. ✨&nbsp;🛡️
            </p>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default HomePage;
